import { useRef, useState } from 'react';

import { ILottie } from '@lottielab/lottie-player';

import CopyAnimation from '@/assets/animations/Copy.json';
import LottieAnimation from '@/components/atoms/Lottie';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/atoms/Tooltip';
import { Button } from '@/new/components/shadcn/button';

interface CopyProps {
  copyHandler: () => void;
  tooltipText?: string;
}

export function CopyButton({ copyHandler, tooltipText }: CopyProps) {
  const [copyClicked, setCopyClicked] = useState(false);
  const animationRef = useRef<ILottie>(null);
  const handleCopyClick = () => {
    setCopyClicked(true);
    copyHandler();
    setTimeout(() => {
      setCopyClicked(false);
      animationRef.current?.stop();
    }, 2000);
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="outline" size="sm" onClick={handleCopyClick}>
          <LottieAnimation
            lottieRef={animationRef}
            playing={copyClicked}
            autoplay={copyClicked}
            animationData={CopyAnimation}
            loop={false}
            className="h-3 w-3"
          />
          Copy
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{tooltipText ?? 'Copy to clipboard.'}</p>
      </TooltipContent>
    </Tooltip>
  );
}
